import React, { PureComponent } from "react";
import ReactDOM from "react-dom";
// import PropTypes from 'prop-types';
import device from "current-device";
import GoogleMapReact from "google-map-react";
import { connect } from "react-redux";
import * as Actions from "../../store/actions/index";
import moment from "moment";
import _ from "lodash";
// import $ from 'jquery';
import { CircularProgress } from "material-ui/Progress";
// import MapWrapper from './MapWrapper';
import Marker from "../Marker";
import Cluster from "../Marker/Cluster";
import { Loader } from "../../containers/style.js";
import mapStyles from "./mapStyles.json";
import styled from "styled-components";
import GooglePlaceMarker from "../GooglePlaceMarker";

const MapWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
`;
const InfoCard = styled.div`
  width: 180px;
  transform: translate(5px, calc(-100% - 5px));
  position: absolute;
  z-index: 40;
  background: #fff;
  display: flex;
  cursor: pointer;
  border-radius: 10px;
  box-shadow: 0px 4px 7px 0 rgba(0, 0, 0, 0.2);
  flex-direction: column;
  justify-content: space-between;
  left: ${(props) => props.left};
  top: ${(props) => props.top};
`;
const InfoText = styled.div`
  padding: 13px 15px;
`;
const InfoTitle = styled.div`
  font-size: 0.8rem;
  line-height: 1.2em;
  font-weight: 600;
  color: #0066ff;
`;
const InfoSubTitle = styled.div`
  font-size: 0.7rem;
  line-height: 1.2em;
  color: #0066ff;
`;
const InfoImage = styled.div`
  height: 100px;
  width: 100%;
  cursor: pointer;
  border-radius: 10px 10px 0 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${(props) => props.image});
`;
export class GoogleMap extends PureComponent {
  constructor(props) {
    super(props);
    this.setGoogleMaps = this.setGoogleMaps.bind(this);
    this.state = {
      coords: { x: 0, y: 0 },
      cardWidth: 180,
      infoMargin: 15,
      infoAdjust: true,
      showLoader: false
    };
  }
  static propTypes = {
    // onHoverKeyChange: PropTypes.func
  };
  componentWillReceiveProps() {}
  componentDidMount() {
    // const { locations } = this.props;
    // console.log(this.props);
  }
  componentDidUpdate() {
    const { locations } = this.props;
    const { googleMaps, googleMap } = this.state;
    // console.log('Map did update');
    // if (googleMaps && locations.length > 500) googleMaps.event.clearListeners(googleMap, 'drag');
  }
  createMapOptions = (maps) => {
    return {
      maxZoom: this.props.mapOptions.maxZoom,
      gestureHandling: "greedy",
      styles: mapStyles
    };
  };
  calculateInfoPos() {
    const { cardWidth, infoMargin, coords, mapWidth, infoAdjust } = this.state;
    var moveXby,
      moveYby,
      info = document.getElementById("locInfo");
    var cardHeight = info && info.offsetHeight ? info.offsetHeight : 200;
    if (infoAdjust) {
      moveXby =
        coords.x + cardWidth + infoMargin > mapWidth
          ? coords.x + cardWidth + infoMargin - mapWidth
          : 0;
      moveYby = coords.y - cardHeight < 0 ? 0 - coords.y - cardHeight : 0;
    } else {
      moveXby = 0;
      moveYby = 0;
    }
    var x = moveXby === 0 ? coords.x + "px" : coords.x - moveXby + "px";
    var y = moveYby === 0 ? coords.y + "px" : cardHeight + infoMargin + "px";
    return {
      x: x,
      y: y
    };
  }
  infoWindow() {
    const { hoverItem } = this.state;
    const { infoShown } = this.props;
    var infoPos = this.calculateInfoPos();
    if (infoShown) {
      return (
        <InfoCard id="locInfo" ref="infoCard" left={infoPos.x} top={infoPos.y}>
          <InfoImage
            image={hoverItem.image}
            onClick={() => this.openDetail(hoverItem.item)}
          />
          <InfoText>
            <InfoTitle onClick={() => this.openDetail(hoverItem.item)}>
              {hoverItem.name1 && hoverItem.name1 !== ""
                ? hoverItem.name1
                : hoverItem.title}
            </InfoTitle>
            <InfoSubTitle>
              {hoverItem.name2 && hoverItem.name2 !== ""
                ? hoverItem.name2
                : hoverItem.city}
            </InfoSubTitle>
          </InfoText>
        </InfoCard>
      );
    } else {
      return "";
    }
  }
  openDetail(item) {
    const { onSetDetail, resultsShown, onShowResults } =
      this.props;
    onSetDetail(item);
    if (!resultsShown) onShowResults(true);
  }
  handleClick = () => {
    this.props.onShowInfo(false);
    this.props.onSetHover(null);
    this.setState({
      markerHoverId: null,
      hoverItem: null
    });
  };
  handleChildClick = (key, childProps) => {
    const {
      onReCenterMap,
      mapOptions,
      mapFullHeight,
      onChangeMap,
      onSetHover,
      resultsShown,
      onShowInfo,
      onSlideCarousel,
      onExpandMap,
      wW,
      wH
    } = this.props;
    if (childProps.title && wH > wW) {
      if (resultsShown) {
        onSlideCarousel(childProps.id);
      } else {
        let z = mapOptions.zoom + 1;
        onChangeMap({
          center: {
            lat: childProps.lat,
            lng: childProps.lng
          },
          zoom: z
        });
      }
      if (mapFullHeight && device.mobile()) {
        onReCenterMap(childProps.lat, childProps.lng);
      }
      onExpandMap(false);
    }
    if (childProps.title && !!!device.mobile()) {
      this.setState({ showInfo: false, infoAdjust: true });
      var mapNode = ReactDOM.findDOMNode(this.refs.map).getBoundingClientRect();
      onSetHover(childProps.id);
      this.setState({
        markerHoverId: childProps.id,
        hoverItem: childProps,
        mapWidth: mapNode.width,
        mapHeight: mapNode.height
      });
      this.onSetInfoPos(childProps.lat, childProps.lng);
    } else if (childProps.points && childProps.points.length > 1) {
      let z = mapOptions.zoom + 1;
      onChangeMap({
        center: {
          lat: childProps.lat,
          lng: childProps.lng
        },
        zoom: z
      });
      this.setState({ showInfo: false, infoAdjust: true });
      onShowInfo(false);
    }
  };
  handleChildMouseEnter = (key, childProps) => {
    if (childProps.title) {
      this.props.onSetHover(childProps.id);
    }
  };
  handleChildMouseLeave = (key, childProps) => {
    if (childProps.title) {
      this.props.onSetHover("");
    }
  };

  handleMapChange = ({ center, zoom, bounds }) => {
    const {
      locations,
      mapOptions,
      onShowResults,
      resultsShown,
      onShowInfo,
      onSetHover,
      onChangeMap,
      onSaveClusters
    } = this.props;
    if (this.state.bounds && !resultsShown) onShowResults(true);

    if (zoom !== mapOptions.zoom) {
      this.setState({ showInfo: false, infoAdjust: true });
      onShowInfo(false);
    }
    this.setState({
      bounds: bounds
    });
    // alert(bounds.nw.lat);
    onSetHover(null);
    onChangeMap({ center, zoom, bounds });

    if (locations.length > 0) onSaveClusters();
  };
  onSetInfoPos(lat, lng) {
    var gMaps = this.state.googleMaps;
    var gMap = this.state.googleMap;
    var _this = this,
      pixel,
      pixel2;
    var latLng = new gMaps.LatLng(lat, lng);
    var overlay = new gMaps.OverlayView();
    overlay.draw = function () {};
    overlay.onAdd = function () {
      var projection = this.getProjection();
      pixel = projection.fromLatLngToContainerPixel(latLng);
      _this.setState({ coords: pixel });
      _this.props.onShowInfo(true);
    };
    overlay.setMap(gMap);
    gMaps.event.addListener(gMap, "drag", function () {
      var inBounds = gMap.getBounds().contains(latLng);

      if (!inBounds && _this.props.infoShown) {
        _this.props.onShowInfo(false);
        _this.setState({ infoAdjust: false });
        // gMaps.event.clearListeners(gMap, 'drag');
      } else {
        if (_this.props.infoShown) _this.setState({ infoAdjust: true });
      }
      var info = document.getElementById("locInfo");
      pixel2 = overlay.getProjection().fromLatLngToContainerPixel(latLng);
      _this.setState({ coords: pixel2 });
      var infoPos = _this.calculateInfoPos();
      if (info) {
        info.style.left = infoPos.x + "px";
        info.style.top = infoPos.y + "px";
      }
    });
  }
  setGoogleMaps(maps, map) {
    const {
      locations,
      onSaveClusters,
      mapOptions,
      mapFullHeight,
      onExpandMap,
      onSaveMap,
      onSaveMaps,
      changeMap,
      onSlideCarousel,
      wW,
      wH
    } = this.props;
    var _this = this;
    this.setState({ googleMaps: maps });
    this.setState({ googleMap: map });
    onSaveMap(map);
    onSaveMaps(maps);

    map.addListener("click", function (event) {
      if (event.placeId) {
        event.stop();
      }
    });
    map.addListener("dblclick", function (event) {
      window.setTimeout(function () {
        map.panTo({ lat: event.latLng.lat(), lng: event.latLng.lng() });
      }, 100);
    });
    if (wH > wW && wW < 600) {
      maps.event.addListener(map, "drag", function () {
        // if (!!!mapFullHeight) {
        //   changeMap({
        //     draggable: false,
        //     panControl: false
        //   });
        // }
        onExpandMap(true);
        onSlideCarousel(null);
      });
    }
    // if (locations.length < 500 && mapOptions.zoom <= 11) {
    //   maps.event.addListenerOnce(map, 'drag', function () {
    //     _this.setState({ showLoader: true });
    //     changeMap({
    //       draggable: false,
    //       panControl: false
    //     });
    //   });
    // }
  }
  renderLoader() {
    if (this.state.showLoader && this.props.locations.length < 500) {
      return (
        <Loader>
          <CircularProgress size={80} color="secondary" />
        </Loader>
      );
    } else {
      return "";
    }
  }
  render() {
    const {
      clusters,
      mapOptions,
      changeMap,
      hoverId,
      activeTab,
      resultsShown,
      googlePlaceItem
    } = this.props;
    return (
      <MapWrapper ref="map">
        {this.renderLoader()}
        {this.infoWindow()}
        <GoogleMapReact
          onGoogleApiLoaded={({ maps, map }) => this.setGoogleMaps(maps, map)}
          yesIWantToUseGoogleMapApiInternals
          zoom={mapOptions.zoom}
          center={mapOptions.center}
          options={this.createMapOptions}
          onClick={this.handleClick}
          onChildClick={this.handleChildClick}
          onChange={this.handleMapChange}
          onChildMouseEnter={this.handleChildMouseEnter}
          onChildMouseLeave={this.handleChildMouseLeave}>
          {googlePlaceItem ? (
            <GooglePlaceMarker
              lat={googlePlaceItem.lat}
              lng={googlePlaceItem.lng}
              text={googlePlaceItem.description}
            />
          ) : null}
          {clusters.map((item, index) => {
            var timeframe = moment().subtract(8, "days"),
              timeframe2 = moment().subtract(1, "days");
            var goodGrade = 0,
              badGrade = 0,
              nsGrade = 0,
              goodNowcast = 0,
              poorNowcast = 0,
              showAlertInCluster = false,
              numNowcast = 0,
              numAlerts = 0;
            item.ids = item.ids + "";
            item.ids = item.ids.split(",");
            var idArray = [];
            item.ids.forEach((id) => idArray.push(parseInt(id)));
            item.ids = idArray;
            if (item.numPoints === 1) {
              var loc = item.points[0],
                grade,
                alert;
              var nowcastDate = loc.nowcast_date;
              var gradeDate = loc.grade_updated;
              switch (activeTab) {
                case 1:
                  if (
                    loc.hasOwnProperty("nowcast_pass_flag") &&
                    moment(nowcastDate)
                      .add(7, "hours")
                      .isSameOrAfter(timeframe2)
                  ) {
                    grade =
                      parseInt(loc.nowcast_pass_flag) > 0 ? "good" : "poor";
                  } else {
                    grade = "";
                  }
                  break;
                case 2:
                  if (
                    loc.dry_grade &&
                    loc.dry_grade !== "ns" &&
                    moment(gradeDate).isSameOrAfter(timeframe)
                  ) {
                    grade = loc.dry_grade;
                  } else if (
                    loc.wet_grade &&
                    loc.wet_grade !== "ns" &&
                    moment(gradeDate).isSameOrAfter(timeframe)
                  ) {
                    grade = loc.wet_grade;
                  } else {
                    grade = "ns";
                  }
                  break;
                case 3:
                  if (loc.currentAlerts.length > 0) {
                    var showAlert3 = true;
                  }
                  if (showAlert3) {
                    grade = loc.currentAlerts[0].ActivityType;
                  } else {
                    grade = "";
                  }
                  break;
                case 0:
                default:
                  var showAlert0;
                  if (loc.currentAlerts.length > 0) {
                    showAlert0 = true;
                  }
                  if (showAlert0) {
                    grade = loc.currentAlerts[0].ActivityType;
                  } else if (
                    loc.hasOwnProperty("nowcast_pass_flag") &&
                    moment(nowcastDate)
                      .add(7, "hours")
                      .isSameOrAfter(timeframe2)
                  ) {
                    grade =
                      parseInt(loc.nowcast_pass_flag) > 0 ? "good" : "poor";
                  } else if (
                    loc.dry_grade &&
                    loc.dry_grade !== "ns" &&
                    moment(gradeDate).isSameOrAfter(timeframe)
                  ) {
                    grade = loc.dry_grade;
                  } else if (
                    loc.wet_grade &&
                    loc.wet_grade !== "ns" &&
                    moment(gradeDate).isSameOrAfter(timeframe)
                  ) {
                    grade = loc.wet_grade;
                  } else {
                    grade = "ns";
                  }
                  break;
              }
              var showMarker = false;
              if (activeTab === 0 || activeTab === 2) {
                showMarker = true;
              } else if (activeTab === 1) {
                if (
                  loc.hasOwnProperty("nowcast_pass_flag") &&
                  moment(nowcastDate).add(7, "hours").isSameOrAfter(timeframe2)
                ) {
                  showMarker = true;
                }
              } else if (activeTab === 3) {
                if (showAlert3) {
                  showMarker = true;
                }
              }
              if (showMarker) {
                return (
                  <Marker
                    key={loc.id}
                    id={loc.id}
                    showBalloon={
                      this.state.markerHoverId === loc.id || hoverId === loc.id
                    }
                    item={loc}
                    grade={grade}
                    title={loc.name1 ? loc.name1 : loc.title}
                    city={loc.name2 ? loc.name2 : loc.city}
                    image={loc.image}
                    lat={loc.lat}
                    lng={loc.lng}
                  />
                );
              }
            }

            if (item.numPoints > 1) {
              var itemsWithAlerts = [],
                nowcastItem;
              item.points.forEach((point, i) => {
                var gradeDate = point.grade_updated;
                var nowcastDate = point.nowcast_date;
                if (point.currentAlerts.length > 0) {
                  badGrade++;
                } else if (
                  point.dry_grade &&
                  point.dry_grade !== "ns" &&
                  moment(gradeDate).isSameOrAfter(timeframe)
                ) {
                  switch (point.dry_grade) {
                    case "A":
                    case "A+":
                    case "A-":
                    case "B":
                    case "B+":
                    case "B-":
                      goodGrade++;
                      break;
                    default:
                      badGrade++;
                  }
                } else if (
                  point.wet_grade &&
                  point.wet_grade !== "ns" &&
                  moment(gradeDate).isSameOrAfter(timeframe)
                ) {
                  switch (point.wet_grade) {
                    case "A":
                    case "A+":
                    case "A-":
                    case "B":
                    case "B+":
                    case "B-":
                      goodGrade++;
                      break;
                    default:
                      badGrade++;
                  }
                } else {
                  nsGrade++;
                }
                if (point.currentAlerts.length > 0) {
                  showAlertInCluster = true;
                  numAlerts++;
                  point.alert =
                    point.currentAlerts.length > 0
                      ? point.currentAlerts[0].ActivityType
                      : null;
                  itemsWithAlerts.push(point);
                }
                if (
                  point.hasOwnProperty("nowcast_pass_flag") &&
                  moment(nowcastDate).add(7, "hours").isSameOrAfter(timeframe2)
                ) {
                  if (parseInt(point.nowcast_pass_flag) > 0) {
                    goodNowcast++;
                    point.nowcast = "good";
                    nowcastItem = point;
                  } else {
                    poorNowcast++;
                    point.nowcast = "poor";
                    nowcastItem = point;
                  }
                }
              });

              numNowcast = goodNowcast + poorNowcast;
              let numGrades = goodGrade + badGrade;
              let totalGood = (goodGrade + goodNowcast) / item.numPoints;
              totalGood = totalGood * 100;
              let totalBad = (badGrade + poorNowcast) / item.numPoints;
              totalBad = totalBad * 100;
              goodGrade = goodGrade / item.numPoints;
              badGrade = badGrade / item.numPoints;
              nsGrade = nsGrade / item.numPoints;
              goodNowcast = goodNowcast / numNowcast;
              poorNowcast = poorNowcast / numNowcast;
              goodGrade = goodGrade * 100;
              badGrade = badGrade * 100;
              nsGrade = nsGrade * 100;
              goodNowcast = goodNowcast * 100;
              poorNowcast = poorNowcast * 100;

              var showCluster = false,
                showMarker = false;
              if (activeTab === 0) {
                showCluster = true;
              } else if (activeTab === 1) {
                if (numNowcast > 1) {
                  showCluster = true;
                } else if (numNowcast === 1) {
                  showMarker = true;
                }
              } else if (activeTab === 2) {
                if (goodGrade > 0 || badGrade > 0) {
                  showCluster = true;
                }
              } else if (activeTab === 3) {
                if (showAlertInCluster && itemsWithAlerts.length > 1) {
                  showCluster = true;
                } else if (itemsWithAlerts.length === 1) {
                  showMarker = true;
                }
              }
              if (showCluster && item.numPoints > 1) {
                return (
                  <Cluster
                    key={item.id}
                    lat={item.lat}
                    lng={item.lng}
                    points={item.points}
                    ids={item.ids}
                    isActive={
                      hoverId && item.ids.indexOf(hoverId) !== -1 ? true : false
                    }
                    tab={activeTab}
                    totalGood={totalGood}
                    totalBad={totalBad}
                    goodGrade={goodGrade}
                    badGrade={badGrade}
                    nsGrade={nsGrade}
                    goodNowcast={goodNowcast}
                    poorNowcast={poorNowcast}
                    numNowcast={numNowcast}
                    numAlerts={numAlerts}
                  />
                );
              } else if (showMarker) {
                var markerItem;
                if (activeTab === 1) {
                  markerItem = nowcastItem;
                } else if (activeTab === 3) {
                  markerItem = itemsWithAlerts[0];
                }
                return (
                  <Marker
                    key={markerItem.id}
                    id={markerItem.id}
                    showBalloon={
                      this.state.markerHoverId === markerItem.id ||
                      hoverId === markerItem.id
                    }
                    item={markerItem}
                    grade={
                      activeTab === 3 ? markerItem.alert : markerItem.nowcast
                    }
                    title={
                      markerItem.name1 ? markerItem.name1 : markerItem.title
                    }
                    city={markerItem.name2 ? markerItem.name2 : markerItem.city}
                    image={markerItem.image}
                    lat={markerItem.lat}
                    lng={markerItem.lng}
                  />
                );
              } else {
                return "";
              }
            }
          })}
        </GoogleMapReact>
      </MapWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locations: state.brc.locations,
    activeTab: state.brc.activeTab,
    selectedItem: state.brc.selectedItem,
    googlePlaceItem: state.brc.googlePlaceItem,
    mapOptions: state.brc.mapOptions,
    clusters: state.brc.clusters,
    hoverId: state.brc.hoverId,
    wW: state.brc.wW,
    wH: state.brc.wH,
    infoShown: state.brc.infoShown,
    resultsShown: state.brc.resultsShown,
    markerCount: state.brc.markerCount,
    mapFullHeight: state.brc.mapFullHeight
  };
};

export default connect(mapStateToProps, { ...Actions })(GoogleMap);



// WEBPACK FOOTER //
// ./src/components/GoogleMap/index.js